import { drinkstypes } from "./drinkstypes";
const initialState = {
    mango:0,
    mangoPrice : 0,
    coldCoffee : 0,
    coldCoffeePrice : 0,
    coffee : 0,
    coffeePrice : 0,
    pepsi : 0,
    pepsiPrice : 0,
    drinksItems : 0
}

export const drinksReducer = (state = initialState, {type, payload}) => {
    switch(type) {
        case drinkstypes.MANGO_INCREASE : {
            return {...state, mango : state.mango+1, mangoPrice:state.mangoPrice+payload, drinksItems : state.drinksItems + 1}
        }
        case drinkstypes.MANGO_DECREASE : {
            return {...state, mango : state.mango-1, mangoPrice:state.mangoPrice-payload, drinksItems : state.drinksItems - 1}
        }
        case drinkstypes.COLD_COFFEE_INCREASE : {
            return {...state, coldCoffee : state.coldCoffee+1, coldCoffeePrice:state.coldCoffeePrice+payload, drinksItems : state.drinksItems + 1}
        }
        case drinkstypes.COLD_COFFEE_DECREASE : {
            return {...state, coldCoffee : state.coldCoffee-1, coldCoffeePrice:state.coldCoffeePrice-payload, drinksItems : state.drinksItems - 1}
        }
        case drinkstypes.COFFEE_INCREASE : {
            return {...state, coffee : state.coffee+1, coffeePrice:state.coffeePrice+payload, drinksItems : state.drinksItems + 1}
        }
        case drinkstypes.COFFEE_DECREASE : {
            return {...state, coffee : state.coffee-1, coffeePrice:state.coffeePrice-payload, drinksItems : state.drinksItems - 1}
        }
        case drinkstypes.PEPSI_INCREASE : {
            return {...state, pepsi : state.pepsi+1, pepsiPrice:state.pepsiPrice+payload, drinksItems : state.drinksItems + 1}
        }
        case drinkstypes.PEPSI_DECREASE : {
            return {...state, pepsi : state.pepsi-1, pepsiPrice:state.pepsiPrice-payload, drinksItems : state.drinksItems - 1}
        }
        case drinkstypes.CLEAR_ALL_DRINKS : {
            return initialState
        }
        default : return state
    }
}